module.exports = __webpack_public_path__ + "img/icon_ladder_phone.238a6bea.png";